export default __webpack_public_path__ + "static/media/contractor_cert_blue.8bce1ce9.svg";